import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const endpoint = 'additional-exam'
const Actions = crudActions(endpoint)

const patch = (ctx, data) => new Promise((resolve, reject) => {
  axios.patch(`/${endpoint}/${data.id}/`, data)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const applyDocList = (ctx, queryParams) => axios.get(`/${endpoint}/apply_doc_additional_exam`, { params: queryParams })
export default {
  ...Actions,
  patch,
  applyDocList,
}
